import Badge from 'components/common/Badge/Badge';

/**
 * Examples of Scalyr's badge component
 */

function BadgeExamplePage(): JSX.Element {
  return (
    <section id="badge" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Badge</h1>
      <div className="ExamplesPage__Description">
        A label that catches the eye a bit more than plain text. Useful for showing an item&apos;s status, for example.
      </div>

      <div className="ExamplesPage__ExampleRow">
        <Badge variant="info" className="mr-2">
          Info
        </Badge>
        <Badge variant="success" className="mr-2">
          Success
        </Badge>
        <Badge variant="pending">Pending</Badge>
      </div>
    </section>
  );
}
export default BadgeExamplePage;
